<ecg-nav-menu></ecg-nav-menu>
<router-outlet></router-outlet>
<ecg-toasts aria-live="polite" aria-atomic="true"></ecg-toasts>
<ngx-spinner bdOpacity=0.7 bdColor="rgba(51,51,51,0.5)" size="default" color="#fff" type="ball-clip-rotate"
             [fullScreen]="true">
  <p style="color: white" i18n> Loading... </p>
</ngx-spinner>
